import Vue from 'vue'
import { createStore } from 'vuex'
import { auth, usersCollection } from '../firebase/firebaseConfig.js';
import router from '../router/index.js'
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";


const getInitialState = () => {
    var initState = {
        userProfile: null,
        isLoading: false,
        isLoggedIn: false,
        user: null,
        blogTitle: "",
        blogImage: null,
        blogFile: null,
        blogHTML: null,
        blogImageFileURL: "",
        blogPosts: [],
        userBlogPosts: []

    }
    return initState
}

export default createStore({
    state: getInitialState(),
    getters: {
        blogPostsFeed(state) {
            return state.blogPosts.slice(0, 2);
        },
        blogPostsCards(state) {
            return state.blogPosts.slice(2, 6);
        },
    },
    mutations: {
        setUserProfile(state, payload) {
            state.userProfile = payload;
        },
        updateUser(state, payload) {
            state.user = payload;
        },
        setIsLoading(state, payload) {
            state.isLoading = payload;
        },
        setIsLoggedIn(state, payload) {
            state.isLoggedIn = payload;
        },
        setBlogTitle(state, payload) {
            state.blogTitle = payload;
        },
        setBlogImage(state, payload) {
            state.blogImage = payload;
        },
        setBlogFile(state, payload) {
            state.blogFile = payload;
        },
        setBlogHTML(state, payload) {
            state.blogHTML = payload;
        },
        setBlogImageFileURL(state, payload) {
            state.blogImageFileURL = payload;
        },
        resetState(state) {
            const s = getInitialState();
            Object.keys(s).forEach(key => {
                state[key] = s[key]
            })
        }
    },
    actions: {
        async fetchUserProfile({ commit }) {
            try {
                commit('setIsLoading', true);
                const uid = firebase.auth().currentUser.uid;
                const userProfile = await firebase.firestore().collection('users').doc(uid).get();
                commit('setUserProfile', userProfile.data());
            } catch (error) {
                console.log(error)
            } finally {
                commit('setIsLoading', false);
            }

        },

        async updateUserDetails({ commit }, updatedUserDetails) {
            try {
                commit('setIsLoading', true);
                const uid = firebase.auth().currentUser.uid;
                await firebase.firestore().collection('users').doc(uid).update({
                    name: updatedUserDetails.name
                });
                commit('setUserProfile', updatedUserDetails);
            } catch (error) {
                console.log(error);
            } finally {
                commit('setIsLoading', false);
            }
        },

        async getPosts({ state, commit }) {
            try {
                commit('setIsLoading', true);
                const dataBase = await firebase.firestore().collection("blogPosts").orderBy("blogDate", "desc");
                const dbResults = await dataBase.get();
                dbResults.forEach((doc) => {
                    if (!state.blogPosts.some((post) => post.blogID === doc.id)) {
                        const data = {
                            blogID: doc.data().blogID,
                            blogHTML: doc.data().blogHTML,
                            blogCoverPhoto: doc.data().blogCoverPhoto,
                            blogTitle: doc.data().blogTitle,
                            blogDate: doc.data().blogDate,
                            blogImage: doc.data().blogImage,
                        };
                        state.blogPosts.push(data);
                    }
                });
            } catch (error) {
                console.log(error)
            } finally {
                commit('setIsLoading', false);
            }
        },

        async getUserPosts({ state }) {
            const userId = await firebase.auth().currentUser.uid;
            try {
                const database = await firebase.firestore().collection('blogPosts').where("blogUser", "==", userId);
                const dbResults = await database.get();
                dbResults.forEach((doc) => {
                    if (!state.userBlogPosts.some((post) => post.blogID === doc.id)) {
                        const data = {
                            blogID: doc.data().blogID,
                            blogHTML: doc.data().blogHTML,
                            blogCoverPhoto: doc.data().blogCoverPhoto,
                            blogTitle: doc.data().blogTitle,
                            blogDate: doc.data().blogDate,
                            blogImage: doc.data().blogImage,
                        };
                        state.userBlogPosts.push(data);
                    }
                });
            } catch (error) {
                console.log(error)
            }
        },

        async deletePost({ state }, blogId) {
            try {
                await firebase.firestore().collection('blogPosts').doc(blogId).delete();
                state.userBlogPosts = state.userBlogPosts.filter(userPost => userPost.blogID !== blogId)
                state.blogPosts = state.blogPosts.filter(post => post.blogID !== blogId)
            } catch (error) {
                console.log(error)
            }
        }
    },
    modules: {}
});